"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.toTextWithVisualCarouselSlice = void 0;
var utils_1 = require("@lglp/utils");
var types_1 = require("../../types");
var field_groups_1 = require("../field-groups");
var fields_1 = require("../fields");
var slice_1 = require("./slice");
var toTextWithVisualCarouselSlice = function (data, logger) {
    var imagesWithCredits = data.items
        .map(function (item) { return field_groups_1.toImageWithCredits(item, logger); })
        .filter(Boolean);
    var text = logger.required(fields_1.toRichText(data.primary.text, logger));
    // Test des champs obligatoires
    if (!((imagesWithCredits === null || imagesWithCredits === void 0 ? void 0 : imagesWithCredits.length) && text)) {
        return undefined;
    }
    return utils_1.compact(__assign(__assign({}, slice_1.toSlice(data, types_1.SliceType.TextWithVisualCarousel)), { imagesWithCredits: imagesWithCredits,
        text: text }));
};
exports.toTextWithVisualCarouselSlice = toTextWithVisualCarouselSlice;
//# sourceMappingURL=text-with-visual-carousel-slice.js.map